import React from 'react'
import { Link } from 'react-router-dom'

import { Card, Page, SubNavigation, Text } from '@fielded/shared-ui'

import { getSubViewLinks } from './utils'
import HomeStockReportsTable from './HomeStockReportsTable'

const HomeStockReports = ({
  view,
  pathname,
  reports,
  branches,
  selectedBranch,
  loadingReports,
  loadingReport,
  downloadingReport,
  downloadedReport,
  onSelectBranch,
  onGenerateReport,
  onDownloadReport,
  totalReportsNumber,
  currentOffset,
  onPageChange,
  pageLimit
}) => {
  const subViewLinks = getSubViewLinks(pathname, view)

  return (
    <Page.Panel>
      <Card className='home-stock-reports__card' rounded>
        <section className='home-stock-reports__header-wrapper home-stock-reports__section'>
          <Text.Heading>Stock status reports</Text.Heading>
        </section>
        <section className='home-stock-reports__sub-navigation home-stock-reports__section'>
          <SubNavigation
            items={subViewLinks}
            label='For'
            linkRenderer={({ key, to, className, children }) => (
              <Link key={key} to={to} className={className}>
                {children}
              </Link>
            )}
          />
        </section>

        <HomeStockReportsTable
          view={view}
          reports={reports}
          branches={branches}
          selectedBranch={selectedBranch}
          loadingReports={loadingReports}
          loadingReport={loadingReport}
          downloadingReport={downloadingReport}
          downloadedReport={downloadedReport}
          onSelectBranch={onSelectBranch}
          onGenerateReport={onGenerateReport}
          onDownloadReport={onDownloadReport}
          totalReportsNumber={totalReportsNumber}
          currentOffset={currentOffset}
          onPageChange={onPageChange}
          pageLimit={pageLimit}
        />
      </Card>
    </Page.Panel>
  )
}

export default HomeStockReports
